import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FileText, 
  Search, 
  BarChart3,
  TrendingUp
} from 'lucide-react';

const StatsAndTabs = ({ stats, loading }) => {
  const location = useLocation();
  
  // Get current active tab from location
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('legal-research')) return 'legal-research';
    if (path.includes('case-summary')) return 'case-summary';
    if (path.includes('contract-review')) return 'contract-review';
    if (path.includes('legal-brief')) return 'legal-brief';
    if (path.includes('compliance')) return 'compliance';
    if (path.includes('precedents')) return 'precedents';
    if (path.includes('document-draft')) return 'document-draft';
    if (path.includes('cost-estimate')) return 'cost-estimate';
    if (path.includes('document-analysis')) return 'document-analysis';
    return 'document-analysis'; // default
  };

  const activeTab = getActiveTab();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div>
      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue">
            <FileText size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats?.documentsAnalyzed || 0}</h3>
            <p>Documents Analyzed</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">
            <Search size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats?.researchQueries || 0}</h3>
            <p>Research Queries</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon purple">
            <BarChart3 size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats?.casesSummarized || 0}</h3>
            <p>Cases Summarized</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon orange">
            <TrendingUp size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats?.hoursEstimate || 0}</h3>
            <p>Hours Saved</p>
          </div>
        </div>
      </div>

      {/* Tool Tabs */}
      <div className="tool-tabs">
        <Link 
          to="/dashboard/document-analysis" 
          className={`tool-tab ${activeTab === 'document-analysis' ? 'active' : ''}`}
        >
          Document Analysis
        </Link>
        <Link 
          to="/dashboard/legal-research" 
          className={`tool-tab ${activeTab === 'legal-research' ? 'active' : ''}`}
        >
          Legal Research
        </Link>
        <Link 
          to="/dashboard/case-summary" 
          className={`tool-tab ${activeTab === 'case-summary' ? 'active' : ''}`}
        >
          Case Summary
        </Link>
        <Link 
          to="/dashboard/contract-review" 
          className={`tool-tab ${activeTab === 'contract-review' ? 'active' : ''}`}
        >
          Contract Review
        </Link>
        <Link 
          to="/dashboard/legal-brief" 
          className={`tool-tab ${activeTab === 'legal-brief' ? 'active' : ''}`}
        >
          Legal Brief
        </Link>
        <Link 
          to="/dashboard/compliance" 
          className={`tool-tab ${activeTab === 'compliance' ? 'active' : ''}`}
        >
          Compliance
        </Link>
        <Link 
          to="/dashboard/precedents" 
          className={`tool-tab ${activeTab === 'precedents' ? 'active' : ''}`}
        >
          Precedents
        </Link>
        <Link 
          to="/dashboard/document-draft" 
          className={`tool-tab ${activeTab === 'document-draft' ? 'active' : ''}`}
        >
          Document Draft
        </Link>
        <Link 
          to="/dashboard/cost-estimate" 
          className={`tool-tab ${activeTab === 'cost-estimate' ? 'active' : ''}`}
        >
          Cost Estimate
        </Link>
      </div>
    </div>
  );
};

export default StatsAndTabs;
